import { React, useState } from "react";
import Sidebar from "../../Components/Sidebar/sidebar";
import CompanyInformationData from "./CompanyInfo/companyInformation";
import { Layout } from "antd";
import { Routes, Route } from "react-router-dom";
import UserManagementData from "./UsersSetting/userManagement";
import AppUserData from "./UsersSetting/newInviteEditUser";
import UserProfileData from "./UsersSetting/userProfile";
import HeaderNav from "../../Components/Header/Header";
import InviteUserData from "./UsersSetting/newUserInvite";
import ExportUser from "./UsersSetting/exportUsers";
import ExportUserPdf from "./UsersSetting/exportUserPDF";
import ExportRecordsAnimation from "../Exports/exportRecordsAnimationScreen";
import Roles from "./Roles&Permissions/Roles";
import CreateRole from "./Roles&Permissions/CreateRole";
import ViewRole from "./Roles&Permissions/ViewRole";
import EditRole from "./Roles&Permissions/EditRole";
import CustomAlertsTable from "./CustomAlerts/CustomAlertsTable";
const { Content } = Layout;

const OrganizationSettings = (props) => {
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );

  const listItems =
    userDetails.role_type === "ADMIN" || userDetails.role_type === "SUPER_ADMIN"
      ?
      [
          {
            icon: "agency",
            label: "Company Information",
            link: "company-information",
          },
          {
            icon: "file-setting",
            label: "User Management",
            link: "user-management",
          },
          {
            icon: "roles",
            label: "Roles & Permissions",
            link: "roles-and-permissions",
          },
          {
            icon: "agency",
            label: "Plan Details and Billing",
            link: "plan-details-and-billing",
          },
          {
            icon: "file-setting",
            label: "Custom Alerts",
            link: "custom-alerts",
          },
        ] 
      : 
      [
          {
            icon: "agency",
            label: "Company Information",
            link: "company-information",
          },
          {
            icon: "agency",
            label: "Plan Details and Billing",
            link: "plan-details-and-billing",
          },
        ];

  return (
    <Layout>
      <HeaderNav />
      <Layout>
        <Sidebar headerName="Organization Settings" listItems={listItems} />
        <Layout>
          <Content>
            <Routes>
              <Route
                path="/company-information"
                element={<CompanyInformationData />}
              />
              <Route path="/user-management" element={<UserManagementData />} />
              <Route
                path="/user-management/export-user"
                element={<ExportUser />}
              />
              <Route
                path="/user-management/export-user/export-user-pdf"
                element={<ExportUserPdf />}
              />
              <Route
                path="/user-management/invite-user"
                element={<InviteUserData />}
              />

              <Route
                path="/user-management/edit-user"
                element={<AppUserData />}
              />
              <Route
                path="/user-management/user-profile/"
                element={<UserProfileData />}
              />
              <Route path="/user-management/preparing-export-orders" element={<ExportRecordsAnimation />}/>
              <Route path="/roles-and-permissions" element={<Roles/>}/>
              <Route path="/roles-and-permissions/create-role" element={<CreateRole/>}/>
              <Route path="/roles-and-permissions/view-role" element={<ViewRole/>}/>
              <Route path="/roles-and-permissions/edit-role" element={<EditRole/>}/>
              <Route
                path="/user-management/preparing-export-orders"
                element={<ExportRecordsAnimation />}
              />
              <Route
              path="/custom-alerts"
              element={<CustomAlertsTable />}
            />
           
            </Routes>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default OrganizationSettings;
